/* 
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/

// Detect Electron environment
const isElectron = !!window.electronAPI;

// For Electron: always use production endpoints
// For Web: use environment variables
export const END_POINT = isElectron
  ? "https://server.vmass.vn"
  : (typeof process !== "undefined" &&
      process.env &&
      process.env.REACT_APP_END_POINT) ||
    "http://127.0.0.1:5000";

let rawSocketEndpoint = (typeof process !== "undefined" &&
      process.env &&
      process.env.REACT_APP_END_POINT_SOCKET) ||
    "127.0.0.1:5000";

if (rawSocketEndpoint && !rawSocketEndpoint.startsWith("http")) {
  if (rawSocketEndpoint.includes("127.0.0.1") || rawSocketEndpoint.includes("localhost")) {
    rawSocketEndpoint = "http://" + rawSocketEndpoint;
  } else {
    rawSocketEndpoint = "https://" + rawSocketEndpoint;
  }
}

export const END_POINT_SOCKET = isElectron
  ? "https://server.vmass.vn"
  : rawSocketEndpoint;
export const PASSWORD_DOWNLOAD_REPORT = "vmass";

export const defaultMenuType = "menu-default";

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = "vi";
export const localeOptions = [
  { id: "vi", name: "Tiếng Việt", direction: "ltr" },
  { id: "en", name: "English", direction: "ltr" },
  { id: "jp", name: "日本語", direction: "ltr" },
  { id: "zh", name: "中文", direction: "ltr" },
  { id: "ru", name: "Русский", direction: "ltr" },
];

export const firebaseConfig = {
  apiKey: "AIzaSyBBksq-Asxq2M4Ot-75X19IyrEYJqNBPcg",
  authDomain: "gogo-react-login.firebaseapp.com",
  databaseURL: "https://gogo-react-login.firebaseio.com",
  projectId: "gogo-react-login",
  storageBucket: "gogo-react-login.appspot.com",
  messagingSenderId: "216495999563",
};

export const searchPath = "/app/pages/search";
export const servicePath = END_POINT + "/product";

/* 
Color Options: (old version)
"light.purple", "light.blue", "light.green", "light.orange", "light.red", "dark.purple", "dark.blue", "dark.green", "dark.orange", "dark.red"
*/
export const themeColorStorageKey = "__theme_color";
export const isMultiColorActive = true;
export const defaultColor = "light.blueolympic";
export const isDarkSwitchActive = true;
export const defaultDirection = "ltr";
export const themeRadiusStorageKey = "__theme_radius";
export const colors = [
  "bluenavy",
  "blueyale",
  "blueolympic",
  "greenmoss",
  "greenlime",
  "purplemonster",
  "orangecarrot",
  "redruby",
  "yellowgranola",
  "greysteel",
];
